import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Minus, Square, X, Maximize2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const isElectronEnv = () => typeof window !== 'undefined' && Boolean(window.api);

const TitleBar = () => {
  const { t } = useTranslation('shared');
  const isElectron = isElectronEnv();
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    if (!isElectron) return;

    const checkMaximized = async () => {
      if (window.api?.windowIsMaximized) {
        const maximized = await window.api.windowIsMaximized();
        setIsMaximized(maximized);
      }
    };
    checkMaximized();

    const interval = setInterval(checkMaximized, 500);
    return () => clearInterval(interval);
  }, [isElectron]);

  // Web app'te (tarayıcıda) hiç render etme
  if (!isElectron) return null;

  const handleMinimize = () => window.api?.windowMinimize?.();
  const handleMaximize = async () => {
    await window.api?.windowMaximize?.();
    const maximized = await window.api?.windowIsMaximized?.();
    setIsMaximized(Boolean(maximized));
  };
  const handleClose = () => window.api?.windowClose?.();

  const base = process.env.PUBLIC_URL
    ? process.env.PUBLIC_URL.replace(/\/$/, '')
    : '.';

  return (
    <div
      className="
        drag-region
        h-9 shrink-0
        bg-slate-50 dark:bg-[var(--color-bg-base)]
        border-b border-slate-200 dark:border-white/5
        flex items-center justify-between
        px-4 select-none
        transition-colors duration-300
        z-[9999]
      "
    >
      {/* Sol: Logo */}
      <div className="flex items-center">
        <img
          src={`${base}/darkmode.png`}
          alt="Notes+"
          className="h-3.5 w-auto object-contain"
          draggable={false}
        />
      </div>

      {/* Sağ: Pencere kontrol butonları */}
      <div className="flex items-center no-drag">
        {/* Küçült */}
        <motion.button
          whileHover={{ backgroundColor: 'rgba(148, 163, 184, 0.15)' }}
          whileTap={{ scale: 0.88 }}
          onClick={handleMinimize}
          title={t('titleBar.minimize')}
          className="w-9 h-9 flex items-center justify-center rounded text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 transition-colors duration-150"
        >
          <Minus className="w-3.5 h-3.5" strokeWidth={2} />
        </motion.button>

        {/* Büyüt / Geri Yükle */}
        <motion.button
          whileHover={{ backgroundColor: 'rgba(148, 163, 184, 0.15)' }}
          whileTap={{ scale: 0.88 }}
          onClick={handleMaximize}
          title={isMaximized ? t('titleBar.restore') : t('titleBar.maximize')}
          className="w-9 h-9 flex items-center justify-center rounded text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 transition-colors duration-150"
        >
          {isMaximized
            ? <Square className="w-3 h-3" strokeWidth={2} />
            : <Maximize2 className="w-3 h-3" strokeWidth={2} />
          }
        </motion.button>

        {/* Kapat */}
        <motion.button
          whileHover={{ backgroundColor: '#ef4444' }}
          whileTap={{ scale: 0.88 }}
          onClick={handleClose}
          title={t('titleBar.close')}
          className="w-9 h-9 flex items-center justify-center rounded text-slate-500 dark:text-slate-400 hover:text-white transition-colors duration-150"
        >
          <X className="w-3.5 h-3.5" strokeWidth={2.5} />
        </motion.button>
      </div>
    </div>
  );
};

export default TitleBar;
